/* ============================================================
   DATZZY — Shopify cart controller (Stage 4.1 → 4.2)
   ------------------------------------------------------------
   The ONLY cart module. Shopify Cart JSON is the single source of truth —
   no localStorage, no catalog.js, no duplicated product/cart data.
   Renders the approved DATZZY drawer (.dz-cart-* shell in cart-drawer.liquid).
   PDP (product.js) and collection (collection.js) only call window.dzCart.add().

   Concurrency: cart MUTATIONS (change/remove) run through a single serialized
   promise queue (`chain`) — each waits for the previous, so requests are issued
   in order and responses render in order; a stale response can never overwrite a
   newer cart state. Add uses a separate short lock to swallow rapid double-adds.
   ============================================================ */
(function(){
  if(window.dzCart && window.dzCart._init) return;

  var T = window.DZ_T || function(k){ return k; };
  var addLock = false;              // swallow duplicate rapid adds
  var chain = Promise.resolve();    // serialized mutation queue (change/remove)
  var COLLECTION_URL = '/collections/all';
  var CART_ICON = '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M3 5h2l2.2 11.2a1.6 1.6 0 0 0 1.6 1.3h8.7a1.6 1.6 0 0 0 1.6-1.2L21 8H6.2"/><circle cx="9.5" cy="20.5" r="1.3" fill="currentColor" stroke="none"/><circle cx="18" cy="20.5" r="1.3" fill="currentColor" stroke="none"/></svg>';

  function esc(s){ return String(s == null ? '' : s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;'); }
  function enqueue(task){ var run = chain.then(task, task); chain = run.catch(function(){}); return run; }

  /* ---- money: Shopify-standard formatMoney using the shop money format ----
     Isolated here; handles decimal + zero-decimal currencies via the format
     placeholder; no hardcoded PLN; Markets/EUR compatible. */
  function formatMoney(cents){
    var format = window.dzMoneyFormat || '{{amount}}';
    if(typeof cents === 'string') cents = cents.replace('.', '');
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    function withDelimiters(number, precision, thousands, decimal){
      precision = precision == null ? 2 : precision;
      thousands = thousands == null ? ',' : thousands;
      decimal = decimal == null ? '.' : decimal;
      if(isNaN(number) || number == null) return '0';
      number = (number / 100).toFixed(precision);
      var parts = number.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var frac = parts[1] ? decimal + parts[1] : '';
      return whole + frac;
    }
    var value = '';
    var match = format.match(placeholder);
    switch(match ? match[1] : 'amount'){
      case 'amount': value = withDelimiters(cents, 2); break;
      case 'amount_no_decimals': value = withDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': value = withDelimiters(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': value = withDelimiters(cents, 0, ' ', ''); break;
      case 'amount_with_apostrophe_separator': value = withDelimiters(cents, 2, "'", '.'); break;
      default: value = withDelimiters(cents, 2);
    }
    return format.replace(placeholder, value);
  }

  function root(){ return document.querySelector('[data-cart-drawer]'); }
  function jsonFetch(url, opts){
    opts = opts || {}; opts.headers = opts.headers || {}; opts.headers.Accept = 'application/json';
    return fetch(url, opts).then(function(r){ return r.json().then(function(d){ if(!r.ok){ d = d || {}; d._status = r.status; throw d; } return d; }); });
  }

  /* ---- a11y helpers ---- */
  function setExpanded(v){ document.querySelectorAll('[data-open-cart]').forEach(function(b){ b.setAttribute('aria-expanded', v ? 'true' : 'false'); }); }
  function focusables(r){
    return Array.prototype.filter.call(
      r.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),[tabindex]:not([tabindex="-1"])'),
      function(el){ return el.offsetParent !== null; }
    );
  }
  // Make everything except the drawer's own section inert (inert attr where
  // supported, aria-hidden fallback) so the background can't be reached.
  function setBackgroundInert(hide){
    var r = root(); if(!r) return;
    var keep = r.closest('.shopify-section') || r;
    Array.prototype.forEach.call(document.body.children, function(child){
      if(child === keep || child.tagName === 'SCRIPT') return;
      if(hide){ child.setAttribute('aria-hidden', 'true'); try { child.inert = true; } catch(e){} }
      else { child.removeAttribute('aria-hidden'); try { child.inert = false; } catch(e){} }
    });
  }

  var dz = {
    _init: true,
    _trigger: null,

    get: function(){ return jsonFetch('/cart.js'); },

    add: function(variantId, quantity, properties, sellingPlanId){
      if(addLock) return Promise.resolve(null);
      addLock = true;
      var line = { id: variantId, quantity: quantity || 1 };
      if(properties) line.properties = properties;
      if(sellingPlanId) line.selling_plan = sellingPlanId;
      return jsonFetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [line] }) })
        .then(function(){ return dz.get(); })
        .then(function(cart){ dz.clearError(); dz.render(cart); dz.updateCount(cart); dz.open(); dz.announce('Produkt dodany do koszyka'); addLock = false; return cart; })
        .catch(function(err){ addLock = false; dz.showError((err && (err.description || err.message)) || 'Nie udało się dodać produktu do koszyka.'); return null; });
    },

    refresh: function(){ return dz.get().then(function(cart){ dz.render(cart); dz.updateCount(cart); return cart; }).catch(function(){}); },

    updateCount: function(cart){
      var n = cart ? cart.item_count : 0;
      document.querySelectorAll('[data-cart-count]').forEach(function(el){ el.textContent = n; el.style.display = n > 0 ? 'flex' : 'none'; });
    },

    render: function(cart){
      var items = document.querySelector('[data-cart-items]');
      var foot = document.querySelector('[data-cart-foot]');
      if(!items) return;
      if(!cart || cart.item_count === 0){
        items.innerHTML = '<div class="dz-cart-empty"><div class="dz-cart-empty-ic">' + CART_ICON + '</div><p>' + esc(T('cart.empty')) + '</p><a href="' + COLLECTION_URL + '" class="btn btn-dark">' + esc(T('cart.exploreSystem')) + '</a></div>';
        if(foot) foot.innerHTML = '';
        return;
      }
      items.innerHTML = cart.items.map(function(it){
        var variant = (it.variant_title && it.variant_title !== 'Default Title') ? it.variant_title : '';
        var plan = (it.selling_plan_allocation && it.selling_plan_allocation.selling_plan) ? it.selling_plan_allocation.selling_plan.name : '';
        var sub = [variant, plan].filter(Boolean).join(' · ') || T('cart.oneTime');
        // final_line_price = payable line total (respects line + cart discounts).
        var lineTotal = (it.final_line_price != null) ? it.final_line_price : it.line_price;
        // Missing/broken image → empty white thumb (CSS), never a broken-image icon.
        var img = it.image ? '<img src="' + esc(it.image) + '" alt="' + esc(it.product_title) + '" loading="lazy" decoding="async" onerror="this.remove()">' : '';
        return '<div class="dz-cart-item" data-line-key="' + esc(it.key) + '">' +
            '<div class="dz-cart-thumb">' + img + '</div>' +
            '<div class="dz-cart-meta">' +
              '<div class="dz-cart-name">' + esc(it.product_title) + '</div>' +
              '<div class="dz-cart-sub">' + esc(sub) + '</div>' +
              '<div class="dz-cart-qty"><button type="button" data-cart-dec aria-label="Zmniejsz ilość: ' + esc(it.product_title) + '">−</button><span data-line-qty>' + it.quantity + '</span><button type="button" data-cart-inc aria-label="Zwiększ ilość: ' + esc(it.product_title) + '">+</button></div>' +
            '</div>' +
            '<div class="dz-cart-price">' + formatMoney(lineTotal) + '</div>' +
          '</div>';
      }).join('');
      if(foot){
        // Subtotal from Shopify (authoritative): items_subtotal_price → total_price fallback.
        var subtotal = (cart.items_subtotal_price != null) ? cart.items_subtotal_price : cart.total_price;
        foot.innerHTML =
          '<div class="dz-cart-row"><span>' + esc(T('cart.subtotal')) + '</span><span>' + formatMoney(subtotal) + '</span></div>' +
          '<button class="btn btn-primary btn-block btn-lg" type="button" data-cart-checkout>' + esc(T('cart.checkout')) + '</button>';
      }
    },

    // Scoped loading: disable the affected line's controls + checkout; keep the
    // last valid cart visible. Called with a line element, or no element for the
    // global (checkout) lock only.
    setLoading: function(on, el){
      var co = document.querySelector('[data-cart-checkout]');
      if(co) co.disabled = !!on;
      var r = root();
      if(r){ if(on) r.setAttribute('aria-busy', 'true'); else r.removeAttribute('aria-busy'); }
      if(el){ el.setAttribute('aria-busy', on ? 'true' : 'false'); el.querySelectorAll('button').forEach(function(b){ b.disabled = !!on; }); }
    },

    open: function(trigger){
      var r = root(); if(!r) return;
      dz._trigger = trigger || (document.activeElement && document.activeElement !== document.body ? document.activeElement : null);
      dz._bodyOverflow = document.body.style.overflow;
      dz._bodyPad = document.body.style.paddingRight;
      var sw = window.innerWidth - document.documentElement.clientWidth;   // scrollbar width
      r.classList.add('open');
      /* Lets the header burger morph into the X while the cart is open (chrome.css). */
      document.body.classList.add('cart-open');
      r.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      if(sw > 0) document.body.style.paddingRight = sw + 'px';             // avoid layout shift
      setExpanded(true);
      setBackgroundInert(true);
      var f = focusables(r);
      var target = (window.matchMedia && window.matchMedia('(max-width:1000px)').matches) ? r : (r.querySelector('[data-cart-close]') || f[0]);
      if(target === r) r.setAttribute('tabindex','-1');
      if(target && target.focus) setTimeout(function(){ try { target.focus(); } catch(e){} }, 60);
    },
    close: function(){
      var r = root(); if(!r) return;
      r.classList.remove('open');
      document.body.classList.remove('cart-open');
      r.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = dz._bodyOverflow || '';
      document.body.style.paddingRight = dz._bodyPad || '';
      setExpanded(false);
      setBackgroundInert(false);
      var back = (dz._trigger && document.contains(dz._trigger)) ? dz._trigger : document.querySelector('[data-open-cart]');
      if(back && back.focus){ try { back.focus(); } catch(e){} }
    },

    checkout: function(){ window.location.assign(window.dzCheckoutUrl || '/checkout'); },

    // Polite live-region announcement (non-critical: added / updated / removed).
    announce: function(msg){ var l = document.querySelector('[data-cart-live]'); if(l){ l.textContent = ''; setTimeout(function(){ l.textContent = msg; }, 40); } },

    showError: function(msg){
      var s = document.querySelector('[data-cart-status]');
      if(s){ s.textContent = msg; s.hidden = false; }
      dz.open();
    },
    clearError: function(){ var s = document.querySelector('[data-cart-status]'); if(s){ s.textContent = ''; s.hidden = true; } },

    /* ---- mutations (serialized via the queue) ---- */
    change: function(lineKey, quantity){
      quantity = Math.max(0, parseInt(quantity, 10) || 0);   // never negative
      return enqueue(function(){
        var el = document.querySelector('[data-line-key="' + lineKey + '"]');
        dz.setLoading(true, el);
        return jsonFetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: lineKey, quantity: quantity }) })
          .then(function(cart){ dz.clearError(); dz.render(cart); dz.updateCount(cart); dz.setLoading(false); dz.announce(quantity === 0 ? 'Produkt usunięty z koszyka' : 'Koszyk zaktualizowany'); return cart; })
          .catch(function(err){ dz.setLoading(false, el); dz.showError((err && (err.description || err.message)) || 'Nie udało się zaktualizować koszyka.'); return null; });
      });
    },
    remove: function(lineKey){ return dz.change(lineKey, 0); }
  };
  window.dzCart = dz;

  /* ---- global wiring (event delegation → survives re-renders / Theme Editor) ---- */
  function wire(){
    if(document.documentElement.dataset.dzCartWired) return;
    document.documentElement.dataset.dzCartWired = '1';
    document.addEventListener('click', function(e){
      var t = e.target;
      if(t.closest('[data-cart-close]')){ e.preventDefault(); dz.close(); return; }
      var co = t.closest('[data-cart-checkout]');
      if(co){ e.preventDefault(); if(!co.disabled) dz.checkout(); return; }
      var inc = t.closest('[data-cart-inc]');
      var dec = t.closest('[data-cart-dec]');
      if(inc || dec){
        e.preventDefault();
        var item = t.closest('[data-line-key]');
        if(!item || item.getAttribute('aria-busy') === 'true') return;   // ignore while that line updates
        var key = item.getAttribute('data-line-key');
        var qtyEl = item.querySelector('[data-line-qty]');
        var q = qtyEl ? (parseInt(qtyEl.textContent, 10) || 1) : 1;
        dz.change(key, inc ? q + 1 : q - 1);   // dec from 1 → 0 → Shopify removes the line
      }
    });
    document.addEventListener('keydown', function(e){
      var r = root(); if(!r || !r.classList.contains('open')) return;
      if(e.key === 'Escape'){ dz.close(); return; }
      if(e.key === 'Tab'){                      // focus trap
        var f = focusables(r);
        if(!f.length){ e.preventDefault(); return; }
        var first = f[0], last = f[f.length - 1];
        if(e.shiftKey && document.activeElement === first){ e.preventDefault(); last.focus(); }
        else if(!e.shiftKey && document.activeElement === last){ e.preventDefault(); first.focus(); }
      }
    });
    dz.refresh(); // load existing Shopify cart + header count on every page
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', wire);
  else wire();
})();
